import * as React from "react";
import styled, { css } from "styled-components";
import IconButton from "components/common/IconButton";
const Container = styled.span(
  ({ theme }) => css`
    display: flex;
    padding: 10px;
    background-color: ${theme.colors.table.row.background};

    &:nth-of-type(even) {
      background-color: ${theme.colors.table.row.backgroundStriped};
    }
  `
);
const Header = styled.div`
  flex: 1;
  margin-right: 5px;
`;
const Description = styled.span`
  flex: 2;
`;
const StyledDeleteButton = styled(IconButton)`
  flex: 0;
`;
const PaginatedItem = ({ item: { name, description }, onDeleteItem = void 0, item }) => {
  const deleteButton = typeof onDeleteItem === "function" ? /* @__PURE__ */ React.createElement(StyledDeleteButton, { onClick: () => onDeleteItem(item), name: "close", title: `Remove ${name}` }) : null;
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Header, null, name), /* @__PURE__ */ React.createElement(Description, null, description), deleteButton);
};
export default PaginatedItem;
